<template>
<h1>Uit dienst melden</h1>
<h2>
    <i class="fas fa-spinner fa-spin" v-if="loading"></i>
    <template v-else>{{ employee.first_name }} {{ employee.prefix }} {{ employee.last_name }}</template>
</h2>
<div class="w-50 pt-3">
    <h2 class="pt-4 pb-3 fw-bold">Algemene gegevens</h2>
    <h6 class="py-2">Onderstaande gegevens worden automatisch aan de e-mails toegevoegd:</h6>
    <div class="row">
        <label class="col-auto required-label" :style="{width: '25%'}">Uit dienst op verzoek van</label>
        <div class="col w-100">
            <fieldset class="btn-group w-100" :data-field="item.requested_by">
                <input id='requestedby1' type="radio" name="requestedby" class="btn-check" :value="'werknemer'" v-model="item.requested_by" />
                <label for="requestedby1" class="btn btn-sm">Werknemer</label>
                <input id='requestedby2' type="radio" name="requestedby" class="btn-check" :value="'werkgever'" v-model="item.requested_by" />
                <label for="requestedby2" class="btn btn-sm">Werkgever</label>
            </fieldset>
        </div>
    </div>
    <div class="row">
        <label for="date" class="col-sm-3 col-form-label required-label">Laatste werkdag</label>
        <div class="col-sm-9">
            <input type="date" id="date" v-model="item.date" />
        </div>
    </div>

    <div class="row">
        <label class="col-auto" :style="{width: '25%'}">Document bijleveren</label>
        <div class="col w-100">
            <fieldset class="btn-group w-100" :data-field="item.add_document">
                <input id='profession1' type="radio" name="profession" class="btn-check" :value="''" :checked="true" v-model="item.add_document" />
                <label for="profession1" class="btn btn-sm">Geen document bijvoegen</label>
                <input id='profession2' type="radio" name="profession" class="btn-check" :value="'upload'" v-model="item.add_document" />
                <label for="profession2" class="btn btn-sm">Document uploaden</label>
                <input id='profession3' type="radio" name="profession" class="btn-check" :value="'generate'" v-model="item.add_document" @change="initPell" />
                <label for="profession3" class="btn btn-sm">Document genereren</label>
            </fieldset>
            <div v-show="item.add_document == 'upload'">
                <UploadModule :model="item.document_file" title="Document" description="kunt u hier uploaden" type="pdf" :owner="'contractFile'" ref="contractFileUpload"
                                @addFile="(e) => addNAWFile(e)" @removeFile="removeNAWFile" />
            </div>
            <div v-show="item.add_document == 'generate'" class="mb-4">
                <div id="pell" class="pell" />
            </div>
        </div>
    </div>

    
    <h2 class="pt-4 pb-3 fw-bold">Bericht naar IBEO</h2>
    <h6>Vermeld hier eventuele aanvullende afspraken met betrekking tot de uitbetaling van vakantiegeld, transitievergoeding en andere relevante zaken die je graag aan IBEO wil laten weten voor een goede verwerking.</h6>

    <div class="row">
        <label for="subject" class="col-sm-3 col-form-label required-label">{{$t('employee.mail_subject')}}</label>
        <div class="col-sm-9" style="padding-top: 11px">
            {{item.email_subject}}
        </div>
    </div>
    <div class="row">
        <label for="contents" class="col-sm-3 col-form-label required-label">{{$t('form.message')}}</label>
        <div class="col-sm-9">
            <textarea v-model="item.email_body" id="contents" rows="8" :disabled="loading"></textarea>
        </div>
    </div>
    <div class="d-flex justify-content-between pt-4 pb-3">
        <h2 class="fw-bold">Bericht naar medewerker</h2>
        <div class="col-sm-xs">
            <label class="bs-switch">
                <input v-model="item.send_employee_mail" :disabled="loading" type="checkbox" />
                <span class="bs-slider"></span>
            </label>
        </div>
    </div>
    <template v-if="item.send_employee_mail">
        <h6>Hiermee kan je ook direct een bevestiging aan de werknemer sturen</h6>
        <div class="row pt-1">
            <label for="subject" class="col-sm-3 col-form-label required-label">{{$t('employee.mail_subject')}}</label>
            <div class="col-sm-9">
                <input type="text" id="subject" v-model="item.email_subject_employee" :disabled="loading" />
            </div>
        </div>
        <div class="row">
            <label for="contents" class="col-sm-3 col-form-label required-label">{{$t('form.message')}}</label>
            <div class="col-sm-9">
                <textarea v-model="item.email_body_employee" id="contents" rows="8" :disabled="loading"></textarea>
            </div>
        </div>
    </template>
    <div class="row justify-content-between mb-2">
      <div class="col-5 text-start">
        <button type="button" class="btn px-5 secondary-button" @click="back">{{ $t('form.back') }}</button>
      </div>
      <div class="col-7 text-end">
        <button type="button" class="btn px-5 btn-success" id="savebutton" @click="validate()" :disabled="isSaving">{{ $t('form.send') }}</button>
      </div>
    </div>
</div>
    

    
</template>

<script>
    import employeeService from '@/services/EmployeeService';
    import companyService from '@/services/CompanyService'
    import UploadModule from '@/components/UploadModule'
    import pellCSS from 'pell/dist/pell.min.css'
    import pell from 'pell'
    import store from '@/store/user'
    import { alsTekst } from '@/logic/contracttekst'
    export default {
        name: 'MailRequestEmployeeExit',
        data() {
            return {
                item: {
                    'email_body': '',
                    'email_subject': '',
                    'email_body_employee': '',
                    'email_subject_employee': '',
                    'date': '',
                    'company_id': 0,
                    'add_document': '',
                    'document_file': null,
                    'document_text': '',
                    'requested_by': '',
                    'external_id': '',
                    'send_employee_mail': true
                },
                endEmployemnt: false,
                submitted: false,
                loading: true,
                forceRefresh: false,
                saveButton: null,
                employee: {
                    first_name: ''
                },
                service: {},
                invalid: {},
                companyData: {},
                pellEditor: null
            }
        },
        components: {
            UploadModule
        },
        methods: {
            validate(){
                if(!this.item.email_body || !this.item.email_subject || !this.item.date || (this.item.send_employee_mail && (!this.item.email_subject_employee || !this.item.email_body_employee)) || !this.item.requested_by) return false;
                this.saveButton.disabled = true;
                employeeService.mail(this.item, this.item.external_id).then(response => {
                    this.$toast.success(this.$t('overview.email_sent'));
                    this.back();
                }).catch(error => {
                    this.toastError(error)
                    console.log('error', error)
                }).finally(() => {
                    this.saveButton.disabled = false;
                });
            },
            setData(data) {
                this.loading = false;
                this.saveButton.disabled = false;
                this.endEmployemnt = data.endEmployemnt;
                this.wontBeEmployed = data.wontBeEmployed;
                this.forceRefresh = data.endEmployemnt || data.wontBeEmployed;
                const id = data.contract ? data.contract.id : null;
                const employeeName = data.first_name + (data.prefix ? (' ' + data.prefix + ' ') : ' ') + data.last_name.replace('*', '');

                this.item = {
                    'email_body': `Beste medewerker van IBEO,\n\nWilt u ${employeeName} van ${store.getters.getCurrentCompanyName} met personeelsnummer ${data.external_id} uit dienst melden? Alvast dank voor uw medewerking.\n\n`,
                    'email_subject': `Uitdienstmelding: ${employeeName}, ${data.external_id}, ${store.getters.getCurrentCompanyName}`,
                    'email_body_employee': '',
                    'email_subject_employee': '',
                    'company_id': store.getters.getCurrentCompanyId,
                    'date': new Date().toISOString().split('T')[0],
                    'customer_id': store.getters.getCurrentCustomerId,
                    'employee_id': data.employee_id,
                    'employee_email': data.email,
                    'id': id,
                    'add_document': this.item.add_document,
                    'document_file': this.item.document_file,
                    'document_text': '',
                    'requested_by': this.item.requested_by,
                    'external_id': data.external_id,
                    'send_employee_mail': true
                };
                this.setPellText();
            },
            back(){
                this.$router.push({ name: 'employees' });
            },
            addNAWFile(file){
                this.item.document_file = file;
            },
            removeNAWFile(){
                this.item.document_file = null;
            },
            initPell(){
                if(this.pellEditor != null) return;
                const pellElement = document.getElementById('pell');
                pellElement.innerHTML = '';
                this.$nextTick(() => {
                    this.pellEditor = pell.init({
                        element: pellElement,
                        onChange: html => { this.item.document_text = html; },
                        actions: [ 'bold', 'italic', 'underline', 'heading1', 'heading2', 'paragraph', 'olist', 'ulist' ]
                    });
                    // Safari voert execCommand('formatBlock') uit zonder de DOM te wijzigen maar vuurt
                    // wel opnieuw een input-event af, waardoor pell's eigen oninput zichzelf synchroon
                    // blijft aanroepen tot de stack vol is (Sentry IBEO-HR-VUE-10). Bij zo'n overflow
                    // wordt onChange nooit afgemaakt en loopt het opgeslagen document achter op het
                    // scherm. Deze guard laat de binnenste ronde direct terugkeren.
                    const pellContent = this.pellEditor.content;
                    const pellOnInput = pellContent.oninput;
                    let pellBusy = false;
                    pellContent.oninput = event => {
                      if(pellBusy) return;
                      pellBusy = true;
                      try { pellOnInput.call(pellContent, event); }
                      finally { pellBusy = false; }
                    };
                    this.$nextTick(this.setPellText);
                });
            },
            setPellText(){
                if(this.pellEditor){
                    // De namen zijn tekst en de editor krijgt HTML: als tekst
                    // invullen, zie logic/contracttekst.js (H14).
                    let templateText = `Beste ${alsTekst(this.employee.first_name)},

Middels deze brief delen we je mede, met inachtneming van de wettelijke aanzegtermijn, dat de arbeidsovereenkomst niet verlengd wordt en van rechtswege zal eindigen op de overeengekomen einddatum.

Wij verzoeken je vriendelijk om na je laatste werkdag  alle in bruikleen verstrekte bedrijfseigendommen, zoals bedrijfskleding en sleutels, in te leveren bij je Storemanager.

Uiterlijk een maand nadat je arbeidsovereenkomst is geëindigd, zal de eindafrekening van salaris plaats vinden.

Bedankt voor je inzet en wij wensen je veel succes in je verdere loopbaan.  

Met vriendelijke groet,

${alsTekst(this.companyData.name)}

${alsTekst(this.companyData.company_director)}`;
                    this.pellEditor.content.innerHTML = templateText.replaceAll('\n', '<br>');
                    this.item.document_text = templateText.replaceAll('\n', '<br>');
                }
            }
        },
        mounted () {
            this.saveButton = document.getElementById('savebutton');

            const href = window.location.href;
            const splitHref = href.split('/');
            let id = splitHref[splitHref.length - 1];
            if(id.includes('?')){
                id = id.split('?')[0];
            }
            
            const hasNMBRSLink = id > 99999;
            if(!hasNMBRSLink){
                this.$toast.error('Medewerker niet gevonden in NMBRS.');
                this.$router.push({ name: "employees" });
                return;
            }
            this.loading = true;
            employeeService.showFromNMBRS(id, store.getters.getCurrentCompanyId, store.getters.getCurrentCustomerId).then(response => {
                this.employee = response.data;
                this.setData(this.employee);
            });

            companyService.show(store.getters.getCurrentCompanyId).then(response => {
              this.companyData = response.data;
            }).catch(e => console.log(e));
        }
    }
</script>

<style scoped>
textarea:disabled {
    background-color: #ddd !important;
    opacity: 1 !important;
}
/* The switch - the box around the slider */
.bs-switch {
    position: relative;
    display: inline-block;
    width: 55px;
    height: 28px;
}
.bs-switch.thin {
    width: 46px !important;
    height: 20px !important;
}

.bs-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.bs-slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    cursor: pointer
}

input:disabled + .bs-slider {cursor: not-allowed !important}
input:disabled:checked + .bs-slider{ background-color: #ada !important }
input:disabled:not(:checked) + .bs-slider{ background-color: #eaeaea !important }

.bs-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%
}
.bs-switch.thin .bs-slider:before {
    height: 12px !important;
    width: 12px !important;
}

input:checked + .bs-slider {
    background-color: #43A047;
}

input:focus + .bs-slider {
    box-shadow: 0 0 1px #43A047;
}

input:checked + .bs-slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}
</style>